import React, { useState } from 'react';
import { Tag, Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

import styles from './EnterpriseClientCheckbox.module.less';

type Props = {
  isEnterpriseClient?: boolean;
  onChange: (isEnterpriseClient: boolean) => Promise<void>;
};

export default function EnterpriseClientCheckbox(props: Props) {
  const { isEnterpriseClient, onChange } = props;
  const [loading, setLoading] = useState(false);

  const handleChange = async (event: CheckboxChangeEvent) => {
    setLoading(true);
    try {
      await onChange(event.target.checked);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tag className={styles.enterpriseClientTag}>
      <Checkbox
        checked={!!isEnterpriseClient}
        disabled={loading}
        onChange={handleChange}
      >
        Is Enterprise Client
      </Checkbox>
    </Tag>
  );
}
